export const SETTINGS = {
  DEFAULT_SETTINGS: "الإعدادات الإفتراضية",
  HEADER: "الفترات",
  PRICE_LIMIT: "التسعير",
  ENTER_CORRECT_VALUE: "أدخل القيمة الصحيحة",
  DELIVERY_PERIOD: "فترة التسليم",
  MAXIMUM_PRICE_OF_PRODUCT: "الحد الأقصى لسعر المنتج",
  SERVICE_FEE: "قيمة خدمة وفّي",
  TABBY_FEE: "قيمة خدمة تابي",
  DEFAULT_DELIVERY_PERIOD: "فترة التسليم الافتراضية",
  DEFAULT_INSPECTION_PERIOD: "التقصير في الفترة",
  RIAL: "ريال",
  DAY: "يوم",
  CONFIRM: "تأكيد",
  SUCCESSFULY_CHANGED: "لقد نجحت في تغيير حد السعر",
};
